import { render, staticRenderFns } from "./NonsenseIcon.vue?vue&type=template&id=76e396b8&"
import script from "./NonsenseIcon.vue?vue&type=script&lang=js&"
export * from "./NonsenseIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports